<template>
    <div>
        <h2 class="text-center">PHIẾU THAY ĐỔI THÔNG TIN</h2>
        <table class="mx-auto table-border">
            <thead>
                <tr>
                    <th class="text-center text-no-wrap">#Chứng từ</th>
                    <th class="text-center text-no-wrap">PHÒNG</th>
                    <th class="text-center">Ngày áp dụng</th>
                    <th class="text-center">Trạng thái</th>
                    <th class="text-center">Diễn giải</th>
                    <th class="text-center">Tên thành viên</th>
                    <th class="text-center">SDT</th>
                    <th class="text-center">Số xe</th>
                    <th class="text-center">Máy giặt</th>
                    <th class="text-center">Máy lạnh</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="item in items"
                    :key="item._id"
                >
                    <td class="text-center text-no-wrap">{{ item.change_id }}</td>
                    <td class="text-center text-no-wrap">{{ item.room_id }}</td>
                    <td class="text center text-no-wrap">{{ item.date_change | formatTimeServer }}</td>
                    <td class="text-center">
                        <span v-if="item.is_valid">{{ item.is_change ? "OK" : "Chưa" }}</span>
                        <span v-else>HỦY</span>
                    </td>
                    <td class="text-left">{{ item.note }}</td>
                    <td class="text-left">{{ item.name }}</td>
                    <td class="text-left">{{ item.phone }}</td>
                    <td style="min-width: 100px" class="text-left">{{ item.motorbike }}</td>
                    <td class="text-left">{{ item.washing_machine_text }}</td>
                    <td class="text-left">{{ item.air_conditioner_text }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: "print-phieu-thay-doi-thong-tin",
    props: {
        items: {
            type: Array,
            default: [],
        },
    },
    data(){
        return {}
    }
};
</script>

<style>
</style>